import Vue from 'vue';

export const EventBus = new Vue();



//////////////////
// WEBPACK FOOTER
// ./node_modules/survey-fields/src/EventBus.js
// module id = 3r+M
// module chunks = 0